export const curatedTitle = (title?: string | null) =>
	Boolean(title) ? `LiveCorp - ${title}` : 'LiveCorp';
